import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SrText from 'client/components/SrText';

import SrSafariToolbarSpace from 'client/components/SrSafariToolbarSpace';
import SrModalV2, { MODAL_THEME_SLIDE_UP } from 'client/components/SrModalV2/SrModalV2';
import SrButton, { SR_BUTTON_THEME_ADOBE_GREEN } from 'client/components/SrButton/SrButton';
import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';

class SrSelfTourDoNotLockModal extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
  };

  render() {
    const { onSubmit } = this.props;

    return (
      <SrModalV2
        showCloseButton={false}
        contentMaxWidth="555px"
        padding="0"
        contentPadding="50px 25px 30px"
        theme={MODAL_THEME_SLIDE_UP}
      >
        <SrText
          font="greycliff"
          weight="800"
          size="26"
          lineHeight="33px"
          align="start"
          width="100%"
          display="block"
        >
          Important reminders
        </SrText>
        <SrBox height="26px" />
        <SrFlex align="center" direction="col">
          <img
            style={{ maxWidth: '100%', maxHeight: '250px' }}
            src="/images/do-not-lock-door-illustration.png"
            alt=""
          />
        </SrFlex>
        <SrText
          font="greycliff"
          weight="800"
          size="21"
          lineHeight="33px"
          align="start"
          width="100%"
          display="block"
          padding="10px 0"
        >
          Entrance Door
        </SrText>
        <SrText size="18" font="greycliff" weight="500">
          Please
          <SrText font="greycliff" weight="800">
            {' '}
            DO NOT{' '}
          </SrText>
          lock the door knob when you exit. The door will lock automatically.
        </SrText>
        <SrBox height="26px" />
        <SrText size="18" font="greycliff" weight="500">
          This will ensure that the listing will be available for the other renters.
        </SrText>
        <SrBox height="26px" />
        <SrFlex align="center" direction="col">
          <img
            style={{ maxWidth: '100%', maxHeight: '250px' }}
            src="/images/lock-window-illustration.png"
            alt=""
          />
        </SrFlex>
        <SrText
          font="greycliff"
          weight="800"
          size="21"
          lineHeight="33px"
          align="start"
          width="100%"
          display="block"
          padding="10px 0"
        >
          Windows & Back Doors
        </SrText>
        <SrText size="18" font="greycliff" weight="500">
          Please
          <SrText weight="800" font="greycliff">
            {' '}
            DO NOT{' '}
          </SrText>
          leave any windows or back doors unlocked. If you see any that are open, please lock them.
        </SrText>
        <SrBox height="46px" />
        <SrButton theme={SR_BUTTON_THEME_ADOBE_GREEN} onClick={onSubmit}>
          I understand
        </SrButton>

        <SrSafariToolbarSpace />
      </SrModalV2>
    );
  }
}

SrSelfTourDoNotLockModal.displayName = 'SrSelfTourDoNotLockModal';

export default SrSelfTourDoNotLockModal;
